export default __webpack_public_path__ + "2c87f8b35f405806e3bf355b8038713b.jpg";